import { IBranding } from "lobbie";
import BrandLogo from "src/components/shared/elements/BrandLogo";
import { LOBBIE_COLORS } from "src/utils/colors";

interface IProps {
    branding: IBranding;
}

const SchedulingBrandingLogo: React.FC<IProps> = ({ branding }) => {
    const {
        isUsingCustomLogoImage,
        logoImageS3ObjectPath,
        logoS3Url,
        logoName,
        logoCircleColor,
        logoLetterColor,
    } = branding;

    if (isUsingCustomLogoImage && (logoS3Url || logoImageS3ObjectPath)) {
        return (
            <img
                style={{ maxHeight: 100 }}
                src={logoS3Url || logoImageS3ObjectPath}
                alt={logoName}
            />
        );
    } else {
        return (
            <BrandLogo
                logoCircleColor={logoCircleColor || LOBBIE_COLORS.primary}
                logoLetterColor={logoLetterColor || LOBBIE_COLORS.white}
                logoName={logoName}
                isPrinting={false}
            />
        );
    }
};

export default SchedulingBrandingLogo;
